import { MutationOptions, useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import api from '../../api';

type TData = void;
type TVariables = string;

export function useCancelOrderMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['cancel-order'],
    mutationFn: (orderId: TVariables) => api.order.cancel(orderId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['orders'],
      });
    },

    ...options,
  });
}
